import { IonContent, IonHeader, IonPage, useIonViewWillLeave } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import CustomTable from "../components/CustomTable";
import Footer from "../components/Footer";
import ReportModal from "../components/ReportModal";
import ResultsText from "../components/ResultsText";
import RouteText from "../components/RouteText";
import Toolbar from "../components/Toolbar";
import AppContext from "../providers/AppContext";
import { TABLE_COLUMNS_REPORTS } from "../utils/Columns";
import { Report } from "../utils/Interfaces";

const IndividualLocations: React.FC<RouteComponentProps> = props => {
  const appContext = useContext(AppContext);

  const [showModal, setShowModal] = useState(false);
  const [reports, setReports] = useState<Report[]>([]);
  const [selectedReport, setSelectedReport] = useState<Report>();

  useEffect(() => {
    if (appContext.jwt === "") {
      // browser refreshed so move back to landing
      props.history.replace("/");
    }
    return () => console.log("unmounting component");
  }, []);

  useIonViewWillLeave(() => {
    appContext.setSelectedLocationCluster(null);
  }, []);

  useEffect(() => {
    const newArr: Report[] = [];
    appContext.selectedLocationCluster?.reportIds.forEach(id => {
      const repFound = appContext.reports.find(rep => rep.id === id);
      if (repFound) {
        newArr.push(repFound);
      }
    });
    setReports(newArr);
  }, [appContext.selectedLocationCluster]);

  return (
    <IonPage>
      <IonHeader>
        <Toolbar props={props} />
      </IonHeader>
      <IonContent>
        <div className="pageContainer">
          <div className="pageContentContainer">
            <RouteText
              routes={[
                { name: "Dashboard", route: "/" },
                { name: "Locations", route: "/locations" },
              ]}
              currentLocation="Individual Locations"
              routeProps={props}
            />
            <h1 className="pageHeader">{`Origin: ${
              appContext.selectedLocationCluster?.originName !== ""
                ? appContext.selectedLocationCluster?.originName
                : "Unknown"
            }`}</h1>
            <div className="numberOfResultsContainer">
              <ResultsText count={reports.length} />
            </div>
            <CustomTable
              rowData={reports}
              cols={TABLE_COLUMNS_REPORTS}
              handleSelectItem={report => {
                setSelectedReport(report as Report);
                setShowModal(true);
              }}
              defaultSort={[{ id: "dateTimeCreated", desc: true }]}
            />
            <ReportModal
              selectedReport={selectedReport}
              showModal={showModal}
              setShowModal={show => setShowModal(show)}
            />
          </div>
          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default IndividualLocations;
